import React from "react";
import HeroSectionDetailsProject from "../layout-details-project/HeroSectionDetailsProject";
import NavBar from "../../communs/NavBar";
import FooterSection from "../../../components/sections/FooterSection";
interface MenuItemLayoutProps {
  title: string;
  subTitle: string;
  urlImage: string;
  mobileImage: string;
  children?: React.ReactNode;
  className?: string;
}
const MenuItemLayout = ({
  title,
  subTitle,
  urlImage,
  mobileImage,
  children,
  className,
}: MenuItemLayoutProps) => {
  return (
    <div className={`takaful--layout-details ${className}`}>
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title={title}
        subTitle={subTitle}
        urlImage={urlImage}
        mobileImage={mobileImage}
      />
      {children}

      <FooterSection />
    </div>
  );
};

export default MenuItemLayout;
